import dayjs from "dayjs";
const relativeTime = require("dayjs/plugin/relativeTime");
const updateLocale = require("dayjs/plugin/updateLocale");

dayjs.extend(updateLocale);
var config = {
  thresholds: [
    { l: "s", r: 1 },
    { l: "ss", r: 59, d: "second" },
    { l: "m", r: 1 },
    { l: "mm", r: 59, d: "minute" },
    { l: "h", r: 1 },
    { l: "hh", r: 23, d: "hour" },
    { l: "d", r: 1 },
    { l: "dd", r: 29, d: "day" },
  ],
};
dayjs.extend(relativeTime, config);
dayjs.updateLocale("en", {
  monthsShort: [
    "Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec",
  ],
  relativeTime: {
    ...dayjs.en.relativeTime,
    past: "%s",
    s: "1s",
    ss: "%ds",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
  },
});

export const timeAgo = unixTimestamp => {
  const targetDate = dayjs.unix(unixTimestamp);
  const currentDate = dayjs();
  const differenceInDays = Math.abs(currentDate.diff(targetDate, "days"));

  if (currentDate.format("YYYY") !== targetDate.format("YYYY")) {
    return targetDate.format("D MMM YYYY");
  }

  if (differenceInDays >= 30) {
    return targetDate.format("D MMM");
  }

  const relativeString = targetDate.fromNow();
  return targetDate.isBefore(currentDate) ? `${relativeString} ago` : relativeString;
};
